import ConsultButton from "@/components/ConsultButton";
import LimitSection from "@/components/LimitSection";
import { Box } from "@chakra-ui/react";
import { getCdnImageSrc, Image, VStack, responsive, colors } from "goi_common";

export default function NowRequestSection() {
  return (
    <VStack width="100%" alignItems="center" background={colors.gray900}>
      <VStack
        maxWidth={`${1200}px`}
        gap="28px"
        css={responsive({
          padding: {
            base: "64px 0px",
            lg: "120px 24px",
          },
        })}
      >
        <VStack width="100%" alignItems="center" gap="16px">
          <Box className="white head_28_b lg_head_42_b">
            지금 견적받고, 무료 제작 혜택 받기
          </Box>

          <ConsultButton text="상조용품 견적 받기" />

          <Box
            padding="20px"
            background={colors.white}
            borderRadius="10px"
            boxShadow="0px 0px 12px 0px rgba(255, 255, 255, 0.25), 0px 0px 24px 0px rgba(241, 131, 52, 0.50);"
            css={responsive({
              width: { base: "340px", lg: "500px" },
              height: "auto",
            })}
          >
            <Image
              src={getCdnImageSrc(`b2b/disposal/now-request.png`)}
              width="100%"
              height="auto"
              alt=""
            />
          </Box>
        </VStack>

        <LimitSection />
      </VStack>
    </VStack>
  );
}
